import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

//COMPONENTS
import ListDisplay from "../navBar/subMenuListDisplay";
import PageSettings from "./files/pageSettings";
import PodPages from "./files/podPages";

function PodRouter(props) {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    return (
        <div>
            {isLoaded && (
                <div>
                    <Routes>
                        <Route path="/list" exact element={<ListDisplay section="pages" items={props.items} SPODSystems={props.SPODSystems} />} />
                        <Route path="/list/:pod" element={<PodPages />} />
                        <Route path="/settings/:pod/:id" element={<PageSettings />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
